
























import {Component, Emit, Model, Prop, Watch} from "vue-property-decorator";
import {FreightServiceStore} from "@/modules/freightservices/store";
import debounce from "lodash/debounce";
import FreightServiceLabel from "@/modules/freightservices/List/components/Label.vue";
import {FreightServiceParams} from "@/modules/freightservices/params";
import {CommonStatus} from "@/enums/status";
import {FreightService} from "@/interfaces/entity";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "FreightServiceSelector",
    components: {FreightServiceLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';
    @Model("change")
    readonly freightServiceRowGuid!: string | string[];

    @Emit('change')
    handleChange(value: string) {
        if (!value) {
            this.handleSearch(value, this);
        }
        return value;
    }

    @Prop({default: false, type: Boolean})
    readonly disabled!: boolean;

    @Prop({default: "Chọn dịch vụ", type: String})
    readonly placeholder!: string;

    @Prop({default: "default", type: String})
    readonly mode!: string;

    @Prop({default: undefined, type: Number})
    readonly type!: number;

    @Prop({default: false, type: Boolean})
    readonly hasDefault!: boolean;

    @Prop({ default: undefined })
    readonly customerRowGuid!: string;

    @Prop({ default: undefined })
    readonly postOfficeRowGuid!: string;

    @Prop({ default: false })
    readonly isAll!: boolean;

    @Prop({ default: true })
    readonly refreshData!: boolean;

    freightServices: Array<FreightService> = [];

    get ids() {
        return FreightServiceStore.ids;
    }

    async created() {
        try {
            if (!this.isAll) {
                await this.getFreightServicesOfCustomer({
                    ...{},
                    customerRowGuid: this.customerRowGuid ? this.customerRowGuid : undefined
                })
            } else {
                await this.getFreightServices({
                    ...new FreightServiceParams(),
                    status: CommonStatus.Active,
                    postOfficeRowGuid: this.postOfficeRowGuid || undefined
                });
            }
            if (this.hasDefault) {
                this.pickDefault();
            }
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã có lỗi xảy ra");
        }
    }

    @Watch('customerRowGuid')
    async onChangeCustomerRowGuid(val: any, oldVal: any) {
        if (val !== oldVal) {
            await this.getFreightServicesOfCustomer({
                ...{},
                customerRowGuid: val
            })
        }
    }

    async getFreightServices(params: any) {
        this.freightServices = await FreightServiceStore.listFreightService({ params, refresh: this.refreshData });
    }

    async getFreightServicesOfCustomer(params: any) {
        this.freightServices = await FreightServiceStore.listFreightServiceOfCustomer(params);
    }

    onSearch(val: any) {
        this.handleSearch(val, this);
    }

    handleSearch = debounce(async (value: string, vm: any) => {
        if (!this.isAll) {
            await vm.getFreightServicesOfCustomer({
                ...{},
                search: value,
                customerRowGuid: this.customerRowGuid ? this.customerRowGuid : undefined
            })
        } else {
            await FreightServiceStore.listFreightService({
                params: {
                    ...new FreightServiceParams(),
                    search: value,
                    status: CommonStatus.Active,
                    postOfficeRowGuid: this.postOfficeRowGuid || undefined
                },
                refresh: false
            });
        }
    }, 500);

    pickDefault() {
        if (this.freightServiceDefault)
            this.handleChange(this.freightServiceDefault as any);
    }

    // @Watch('postOfficeRowGuid')
    // onchangePostOfficeRowGuid(val: any) {
    //     FreightServiceStore.listFreightService({
    //         params: {
    //             ...new FreightServiceParams(),
    //             status: CommonStatus.Active,
    //             postOfficeRowGuid: val
    //         }
    //     });
    // }
}
